import { render, staticRenderFns } from "./FinishV2.vue?vue&type=template&id=3177efde&scoped=true"
import script from "./FinishV2.vue?vue&type=script&lang=ts"
export * from "./FinishV2.vue?vue&type=script&lang=ts"
import style0 from "./FinishV2.vue?vue&type=style&index=0&id=3177efde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177efde",
  null
  
)

export default component.exports